import { createAction, createSlice, PayloadAction } from "@reduxjs/toolkit";

import type { RootState } from "../../../store";
import type {
  LicenceAgreementFile,
  LicenceAgreementLastUpdate,
} from "../models/TermsAndConditions";

interface InitialState {
  code: null | string;
  licenceAgreement: {
    lastUpdate: LicenceAgreementLastUpdate | null;
    file: LicenceAgreementFile | null;
  };
}

const initialState: InitialState = {
  code: null,
  licenceAgreement: {
    lastUpdate: null,
    file: null,
  },
};

export const operationPath = {
  qrCode: ["userSettings", "qrCode"],
  enableTwoFA: ["userSettings", "enableTwoFA"],
  disableTwoFA: ["userSettings", "disableTwoFA"],
  licenceAgreementLastUpdate: [
    "userSettings",
    "licenceAgreement",
    "lastUpdate",
  ],
  licenceAgreementFile: ["userSettings", "licenceAgreement", "file"],
  acceptLicenceAgreement: ["userSettings", "licenceAgreement", "accept"],
};

export const slice = createSlice({
  name: "userSettings",
  initialState,
  reducers: {
    setQrCode: (state, action) => {
      state.code = action.payload;
    },
    setLicenceAgreementLastUpdate: (
      state,
      action: PayloadAction<LicenceAgreementLastUpdate>
    ) => {
      state.licenceAgreement.lastUpdate = action.payload;
    },
    setLicenceAgreementFile: (
      state,
      action: PayloadAction<LicenceAgreementFile>
    ) => {
      state.licenceAgreement.file = action.payload;
    },
  },
});

export const {
  setQrCode,
  setLicenceAgreementLastUpdate,
  setLicenceAgreementFile,
} = slice.actions;

export const getQRCode = createAction("getQRCode");
export const enableTwoFA = createAction<string>("enableTwoFA");
export const disableCurrentUser2FA = createAction<{ code: string }>(
  "disableCurrentUser2FA"
);

export const fetchLicenceAgreementLastUpdate = createAction(
  "fetchLicenceAgreementLastUpdate"
);

export const fetchLicenceAgreementFile = createAction<{ version: string }>(
  "fetchLicenceAgreementFile"
);

export const acceptLicenceAgreement = createAction("acceptLicenceAgreement");

export default slice.reducer;

export const selectQRCode = (state: RootState) =>
  state.userSettings.code
    ? btoa(unescape(encodeURIComponent(state.userSettings.code)))
    : null;

export const selectLicenceAgreement = (state: RootState) =>
  state.userSettings.licenceAgreement;
